import { isNotNilOrEmpty } from '../../value/isNotNilOrEmpty';
/**
 * Gets a function used to sort by the employee's full name (for use with lodash/sortBy or lodash/orderBy)
 *
 * @aka sortByFullName
 * @category Sorting
 * @template {T}
 * @param {string | symbol} [preferredFirstNameKey=preferredFirstName] - The key in the object for the employee's preferred first name
 * @param {string | symbol} [firstNameKey=firstName] - The key in the object for the employee's first name
 * @param {string | symbol} [lastNameKey=lastName] - The key in the object for the employee's last name
 * @returns {function} - The sorting function
 * @example
 * sortReduceFullName()({ firstName: 'Homer', lastName: 'Simpson' });
 * //=> homer simpson
 *
 * sortReduceFullName()({ firstName: 'Homer', lastName: 'Simpson', preferredFirstName: 'Mr. Plow' });
 * //=> mr. plow simpson
 *
 * // key overrides
 * sortReduceFullName('preferred', 'first', 'last')({ first: 'Homer', last: 'Simpson', preferred: 'Mr. Plow' });
 * //=> mr. plow simpson
 * @docgen_example
 * sortReduceFullName()({ firstName: 'Homer', lastName: 'Simpson' });
 */
export var sortReduceFullName = function (preferredFirstNameKey, firstNameKey, lastNameKey) {
    if (preferredFirstNameKey === void 0) { preferredFirstNameKey = 'preferredFirstName'; }
    if (firstNameKey === void 0) { firstNameKey = 'firstName'; }
    if (lastNameKey === void 0) { lastNameKey = 'lastName'; }
    return function (x) {
        var fullName = getFullNameByKeys(preferredFirstNameKey, firstNameKey, lastNameKey)(x);
        return isNotNilOrEmpty(fullName) ? fullName.toLowerCase() : null;
    };
};
// Private
var getFullNameByKeys = function (preferredFirstNameKey, firstNameKey, lastNameKey) { return function (x) {
    var firstName = x[preferredFirstNameKey] || x[firstNameKey];
    var lastName = x[lastNameKey];
    var fullName = '';
    if (isNotNilOrEmpty(firstName)) {
        fullName = firstName;
    }
    if (isNotNilOrEmpty(lastName)) {
        if (isNotNilOrEmpty(fullName)) {
            fullName += ' ' + lastName;
        }
        else {
            fullName = lastName;
        }
    }
    return isNotNilOrEmpty(fullName) ? fullName : null;
}; };
